module.exports = __webpack_public_path__ + "img/IMG_1410.d2521a97.jpeg";